export class MuInspector {
    public static register() {
        // @ts-ignore
        window.MuInspector = MuInspector;
    }

    public static getClassPath(element: HTMLElement|null) {
        const res = [];
        let pe = true;
        while (element) {
            if (element.classList.length > 0) {
                if (!pe) res.push(' > ');
                res.push('.' + Array.from(element.classList).join('.'));
                pe = false;
            } else {
                pe = true;
            }
            element = element.parentElement;
        }

        return res.reverse().join('');
    }
}